var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      attrs: {
        modalId: "premium-enrollment-before-you-upgrade-modal",
        size: "modal-md"
      }
    },
    [
      _c(
        "ModalHeader",
        {
          style: { padding: "10px 10px 10px 10px" },
          attrs: {
            title: _vm.$t("xBeforeYouUpgrade"),
            icon: "far fa-circle-dollar"
          }
        },
        [
          _c("div", { staticClass: "cols-auto" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-icon-button btn-icon-button--gray",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.closeModal(
                      "premium-enrollment-before-you-upgrade-modal"
                    )
                  }
                }
              },
              [_c("i", { staticClass: "fas fa-times" })]
            )
          ])
        ]
      ),
      _c("ModalBody", [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t(
                    "xToUpgradeToPremiumAllProductsMustBeIncludedInYourPlan"
                  )
                ) +
                " "
            )
          ])
        ]),
        _c(
          "div",
          { staticClass: "col-0 mt-1" },
          _vm._l(_vm.apparatusesIncludedInUpgrade, function(apparatus, index) {
            return _c("li", { key: index, staticClass: "ml-2" }, [
              _c("span", [_vm._v(_vm._s(apparatus.apparatusName))])
            ])
          }),
          0
        ),
        _c("div", { staticClass: "row mt-4" }, [
          _c("div", { staticClass: "col" }, [
            _vm._v(" " + _vm._s(_vm.$t("xIfYouDontWantCertainProducts")) + " ")
          ])
        ])
      ]),
      _c("ModalFooter", [
        _c(
          "button",
          {
            staticClass: "btn btn-outline-warning",
            staticStyle: { width: "47%" },
            attrs: {
              type: "button",
              "data-test-hook": "cancel-btn-confirm-delete-modal"
            },
            on: {
              click: function($event) {
                return _vm.closeModal(
                  "premium-enrollment-before-you-upgrade-modal"
                )
              }
            }
          },
          [_vm._v(" " + _vm._s(_vm.$t("xCancel")) + " ")]
        ),
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            staticStyle: { width: "47%" },
            attrs: {
              type: "button",
              "data-test-hook": "continue-to-upgrade-subscription"
            },
            on: {
              click: function($event) {
                return _vm.continueToUpgrade()
              }
            }
          },
          [_vm._v(" " + _vm._s(_vm.$t("xContinue")) + " ")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }